import { connect } from 'react-redux';
import { Dispatch } from 'redux';

import { Action } from '../../actions';
import { goToCampaignModerationOffer } from '../../actions/grid-screen';
import { cancelModerationMessage, confirmModerationMessage } from '../../actions/messages';
import { Messages, MessagesProps } from '../../components/Messages/Messages';
import { LinkTarget } from '../../typings/common';
import { State } from '../../typings/state';
import { TDispatchProps, TStateProps } from '../../typings/utils';

type StateProps = TStateProps<MessagesProps>;
type DispatchProps = TDispatchProps<MessagesProps>;

const mapStateToProps = (state: State): StateProps => {
    return { messages: state.messages.items };
};

const mapDispatchToProps = (dispatch: Dispatch<Action>): DispatchProps => {
    return {
        confirmModerationMessage: (campaignId: string) => {
            dispatch(confirmModerationMessage());
            dispatch(goToCampaignModerationOffer(LinkTarget.self, campaignId));
        },
        cancelModerationMessage: () => dispatch(cancelModerationMessage())
    };
};

export const MessagesContainer = connect<StateProps, DispatchProps>(
    mapStateToProps,
    mapDispatchToProps
)(Messages);
